import { DeliveryBarMachineContextShippingMethod } from '../stateMachines/deliveryBar/types';

/**
 * Matches the selected shipping method to an eligible shipping method from the query
 * to get the correct configurations. This is needed because the selected method
 * might come from customer data (localStorage/remote) without configurations.
 */
export const matchShippingMethodToEligible = (
  selectedMethod: DeliveryBarMachineContextShippingMethod | null | undefined,
  eligibleMethods: DeliveryBarMachineContextShippingMethod[],
): DeliveryBarMachineContextShippingMethod | undefined => {
  if (!selectedMethod) {
    return undefined;
  }

  // If the selected method already has configurations, use it
  if (
    selectedMethod.configurations &&
    selectedMethod.configurations.length > 0
  ) {
    return selectedMethod;
  }

  // Otherwise, find a matching method in the eligible methods by type and carrierId
  const matched = eligibleMethods.find((method) => {
    const typeMatches = method.type === selectedMethod.type;
    const carrierMatches =
      !selectedMethod.carrierId ||
      !method.carrierId ||
      method.carrierId === selectedMethod.carrierId;

    return typeMatches && carrierMatches;
  });

  // If found, merge the selected method with the matched method's configurations
  if (matched) {
    return {
      ...selectedMethod,
      configurations: matched.configurations,
    };
  }

  // If no match found, return the selected method as-is (without configurations)
  return selectedMethod;
};
